if (document.querySelector('.woocommerce-form-login') && document.querySelector('.lost_password')) {
    document.querySelector('#password').closest('.woocommerce-form-row').querySelector('label').append(document.querySelector('.woocommerce-LostPassword a'));
    document.querySelector('.woocommerce-LostPassword').remove();

}

if (document.querySelector('.woocommerce-MyAccount-navigation-link--customer-logout')) {
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.woocommerce-MyAccount-navigation-link--customer-logout a')) return;

        e.preventDefault();

        const logoutLink = e.target.closest('.woocommerce-MyAccount-navigation-link--customer-logout a').getAttribute('href');

        if (window.confirm('Weet u zeker dat u wilt uitloggen?')) {
            window.location.href = logoutLink;
        }
    });
}

if (document.querySelector('.woocommerce-MyAccount-content')) {
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.woocommerce-MyAccount-content a')) return;

        const logoutLink = e.target.closest('.woocommerce-MyAccount-content a').getAttribute('href');

        if (logoutLink.includes('wp-login')) {
            e.preventDefault();
            if (window.confirm('Weet u zeker dat u wilt uitloggen?')) {
                window.location.href = logoutLink;
            }
        }
    });
}

